import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './CustomMultiSelectAdmin.scss';

class CustomMultiSelectAdmin extends Component {
  static propTypes = {
    values: PropTypes
      .arrayOf()
      .isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes
      .arrayOf()
      .isRequired,
    label: PropTypes.string,
    isFocused: PropTypes.bool.isRequired,
    errorText: PropTypes.string,
    multi: PropTypes.bool.isRequired,
    searchable: PropTypes.bool.isRequired,
    closeOnSelect: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    patchUserPrivilege: PropTypes.func.isRequired,
    patchUserDemotePrivilege: PropTypes.func.isRequired,
  };

  static defaultProps = {
    label: 'Role',
    errorText: '',
    closeOnSelect: false,
    placeholder: 'Role',
    disabled: false,
    className: '',
  };

  componentDidMount() {
  }

  changeHandler = (value) => {
    if (value.label === 'Downgrade to user') {
      this.props.patchUserDemotePrivilege(Number(value.value));
    } else if (value.label === 'Upgrade to admin') {
      this.props.patchUserPrivilege(Number(value.value));
    }
  };

  renderArrow = ({ isOpen }) => {
    const arrowClassNames = classNames({ 'arrow-wrapper': true, 'is-open': isOpen });
    return (
      <div className={arrowClassNames}><div className="arrow" /></div>
    );
  };

  render() {
    const {
      name,
      values,
      value,
      isFocused,
      label,
      errorText,
      multi,
      searchable,
      closeOnSelect,
      placeholder,
      disabled,
      className,
    } = this.props;
    const multiSelectClasses = classNames({
      'multi-select': true,
      'show-float-label': isFocused || (value && String(value).length),
      'is-open': isFocused,
      disabled,
      [className]: true,
    });
    const renderPlaceholder = isFocused
      ? ''
      : placeholder;
    return (

      <div className={multiSelectClasses} style={{ display: disabled ? 'none' : 'block' }}>
        <div className="text-field-float-label" style={{ paddingTop: '15px' }}>
          <span>{label}</span>
        </div>
        <Select
          name={name}
          value={value}
          onChange={this.changeHandler}
          onClose={this.blurHandler}
          multi={multi}
          searchable={searchable}
          closeOnSelect={closeOnSelect}
          clearable={false}
          placeholder={renderPlaceholder}
          options={values}
          arrowRenderer={this.renderArrow}
          disabled={disabled}
        />
        <div className="text-field-error-text">
          <span>{errorText}</span>
        </div>
      </div>
    );
  }
}

export default CustomMultiSelectAdmin;



// WEBPACK FOOTER //
// ./src/components/_molecules/CustomMultiSelectAdmin/CustomMultiSelectAdmin.js